import * as React from 'react';

import { useQuery } from '@apollo/client';

import { get as userGet } from 'js/lib/user';

import AdminMyPageHeaderContext from 'bundles/composable-page-header-admin/contexts/AdminMyPageHeaderContext';
import AdminMyPageHeaderQuery from 'bundles/composable-page-header-admin/queries/AdminMyPageHeaderQuery.graphql';
import type {
  AdminMyPageHeaderQuery as AdminMyPageHeaderQueryType,
  AdminMyPageHeaderQueryVariables,
} from 'bundles/composable-page-header-admin/queries/__generated__/AdminMyPageHeaderQuery';

const AdminPageHeaderBffProvider = ({ children }: { children: React.ReactNode }) => {
  const { id: userId } = userGet();

  const { data, error } = useQuery<AdminMyPageHeaderQueryType, AdminMyPageHeaderQueryVariables>(
    AdminMyPageHeaderQuery,
    {
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
      skip: !userId,
    }
  );

  return (
    <AdminMyPageHeaderContext.Provider
      value={{
        myPageHeader: data?.PageHeader?.queryMyPageHeader,
        error,
      }}
    >
      {children}
    </AdminMyPageHeaderContext.Provider>
  );
};

export default AdminPageHeaderBffProvider;
